import { HttpErrorResponse } from '@angular/common/http';
import { PlaylistTrack } from '@app/core/models/Track';

const tag = '[PlaylistTracks]';

export class PlaylistTracksToggle {
  static readonly type = `${tag} toggle state`;
}

export class PlaylistTracksRequest {
  static readonly type = `${tag} request playlist tracks`;
  constructor(public idPlaylist: number) {}
}

export class PlaylistTracksRequestNoLoader {
  static readonly type = `${tag} request playlist tracks without loader`;
  constructor(public idPlaylist: number) {}
}

export class PlaylistTracksSuccess {
  static readonly type = `${tag} success playlist tracks`;
  constructor(public idPlaylist: number, public tracks: PlaylistTrack[]) {}
}

export class PlaylistTracksFailure {
  static readonly type = `${tag} error playlist tracks`;
  constructor(public error: HttpErrorResponse) {}
}

export class MovePlaylistTracksRequest {
  static readonly type = `${tag} request move playlist tracks`;
  constructor(
    public idPlaylist: number,
    public destPosition: number,
    public tracksPosition: number[],
  ) {}
}

export class MovePlaylistTracksSuccess {
  static readonly type = `${tag} success move playlist tracks`;
  constructor(public idPlaylist: number, public tracks: PlaylistTrack[]) {}
}

export class MovePlaylistTracksFailure {
  static readonly type = `${tag} error move playlist tracks`;
  constructor(public error: HttpErrorResponse) {}
}

export class DeletePlaylistTracksRequest {
  static readonly type = `${tag} request delete tracks`;

  constructor(public idPlaylist: number, public tracks: PlaylistTrack[]) {}
}

export class DeletePlaylistTracksSuccess {
  static readonly type = `${tag} success delete tracks`;

  constructor(public idPlaylist: number, public tracks: PlaylistTrack[]) {}
}

export class DeletePlaylistTracksFailure {
  static readonly type = `${tag} error delete tracks`;

  constructor(public error: Error) {}
}
